import { render, staticRenderFns } from "./codicearticolo.vue?vue&type=template&id=19c7f11f&"
import script from "./codicearticolo.vue?vue&type=script&lang=js&"
export * from "./codicearticolo.vue?vue&type=script&lang=js&"
import style0 from "./codicearticolo.vue?vue&type=style&index=0&id=19c7f11f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports